






























import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class BoxDiagramUnitLists extends Vue { 
	@Prop() public text!: string
	@Prop() public totalUnit!: number
	@Prop() public unitLists!: string[]
	@Prop({ default: 210 }) public width!: string

	isUnitList = false 

	isBtn () {
		if (this.unitLists == undefined) {
			return true
		}
		if (this.unitLists.length > 0) {
			return false
		}
		return true
	}

	btnUnit () {
		this.isUnitList === true ? this.isUnitList = false : this.isUnitList = true
	}

}
